/* @ngInject */
const metadata = (
  accountFields,
  accountButtons
) => {
  const self = {}

  self.buttons = [
    accountButtons.delete,
  ]

  self.fields = accountFields

  return self
}

export default metadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/services/metadata.service.js